jQuery('.ume-accordion-wrapper').each(function (index) {
    jQuery(this).attr('id', 'accordion-' + index);
});

// Set data-parent ID to each accordion card
jQuery('.ume-accordion-wrapper [data-parent]').each(function () {
    let get_parent_id = jQuery(this).parent().parent().attr('id');

    jQuery(this).attr('data-parent', '#' + get_parent_id);
});

// Add minus icon for collapse element which is open by default
jQuery('.collapse.show').each(function () {
    jQuery(this).prev('.card-header').find('.fa').addClass('icon-accordion-minus').removeClass('icon-accordion-plus');
});

// Toggle plus minus icon on show hide of collapse element
jQuery('.collapse').on('show.bs.collapse', function () {
    jQuery(this).prev('.card-header').find('.fa').removeClass('icon-accordion-plus').addClass('icon-accordion-minus');
}).on('hide.bs.collapse', function () {
    jQuery(this).prev('.card-header').find('.fa').removeClass('icon-accordion-minus').addClass('icon-accordion-plus');
});

jQuery('.collapse').on('shown.bs.collapse', function () {

    const card = jQuery(this).closest('.card-accordion');
    const cardHeader = jQuery(this).closest('.card-accordion').find('.card-header');
    const elementTop = cardHeader.offset().top;
    const elementBottom = elementTop + cardHeader.outerHeight();
    const viewportTop = jQuery(window).scrollTop();
    const viewportBottom = viewportTop + jQuery(window).height();

    if ((elementBottom > viewportTop && elementTop < viewportBottom) == false) {
        if (card.offset() !== undefined) {
            jQuery('html,body').animate({
                scrollTop: card.offset().top - 200
            });
        }
    }
});
const doStuff = (targetID) => {
    let target = document.querySelector(targetID);
    if (target !== null && target.parentElement.classList.contains('wp-block-ume-ume-accordion-block')) {

        const openTarget = () => {
            target.classList.add('show');
            target.classList.remove('collapse');

            jQuery([document.documentElement, document.body]).animate({
                scrollTop: jQuery(target).offset().top-200
            });

            removeHash();
        };

        const wrapper = target.closest('.ume-accordion-wrapper');
        const openSiblings = wrapper ? jQuery(wrapper).find('.collapse.show').not(target) : jQuery();

        if (openSiblings.length) {
            let remaining = openSiblings.length;
            openSiblings.one('hidden.bs.collapse', () => {
                remaining -= 1;
                if (remaining === 0) {
                    openTarget();
                }
            });
            openSiblings.collapse('hide');
        } else {
            openTarget();
        }
    }

}
const removeHash = () => {
    history.pushState("", document.title, window.location.pathname
        + window.location.search);
}
if (document.querySelector('.ume-accordion-wrapper')) {
    if (window.location.hash) {
        const target = window.location.hash;
        doStuff(target);


    }
    window.addEventListener('hashchange', () => {
        const target = window.location.hash;
        doStuff(target);
    })
}
